module.exports = __webpack_public_path__ + "img/EXALT_ELEVATED.b1bf1111.svg";